import React, { useState, useRef } from "react";
import "./style.scss";

type Props = {
  title: string;
  isAllowed: boolean;
  data: boolean;
  updateData: (val: boolean) => void;
};

export const ProfileCust: React.FC<Props> = ({
  title,
  isAllowed,
  data,
  updateData,
}) => {
  return (
    <div className="profile-cust-container">
      <span className="profile-cust-title">{title}</span>
      <div className="profile-cust-radio" onClick={() => updateData(true)}>
        <input
          type="radio"
          checked={data}
          disabled={!isAllowed}
          onChange={() => {}}
        />
        <span>True</span>
      </div>
      <div
        className="profile-cust-radio"
        onClick={() => updateData(false)}
      >
        <input
          type="radio"
          checked={!data}
          disabled={!isAllowed}
          onChange={() => {}}
        />
        <span>False</span>
      </div>
    </div>
  );
};
